import { requestWithToken as request } from "./api";

export function getResultStateByPeriod(period, initDate, endDate) {
    const result = request.get(
        `/financial_reports_view/get_result_state_by_period/?period=${period}&init_date=${initDate}&end_date=${endDate}`
    );
    return result;
}

// export function saveCartera(
//     company_id,
//     old_analists,
//     new_analists,
//     deleted_analists
// ) {
//     const param = {
//         old_analists: old_analists,
//         new_analists: new_analists,
//         deleted_analists: deleted_analists,
//     };
//     return request.post(`/analyst_view/${company_id}/save_cartera/`, param);
// }
